export default __webpack_public_path__ + "static/media/imageFail.23cccb87.png";